// extracted by css-extract-rspack-plugin
export default {"taskList":"task-list__taskList___gIb52 common__flex___Q2pQy common__column___k70Tz"};